export const initialState = {
  filters: {},
  therapists: [],
  patients: []
};
